import classNames from "classnames";
import React from "react";

import { CollectionResourceType } from "@/shared/domain/collections";
import { capitalizeFirst } from "@/shared/text/capitalizeFirst";

import styles from "./CollectionTypeChip.module.css";

interface CollectionTypeChipProps {
  resourceType: CollectionResourceType;
}

/**
 * A `Record` over the union rather than a switch with a `default`, so a new
 * member type is a compile error here instead of inheriting whichever colour
 * the default arm happened to name. The `??` still covers a `resource_type`
 * outside the union, which arrives through an unchecked response cast.
 */
const BACKGROUND_COLOR_CLASSES: Record<CollectionResourceType, string> = {
  dataset: styles.datasetBackgroundColor,
  event: styles.eventBackgroundColor,
  file: styles.fileBackgroundColor,
  session: styles.sessionBackgroundColor,
};

export const CollectionTypeChip: React.FC<CollectionTypeChipProps> = ({
  resourceType,
}) => {
  const backgroundColorClass =
    BACKGROUND_COLOR_CLASSES[resourceType] ?? styles.fileBackgroundColor;

  return (
    <span className={classNames(styles.chip, backgroundColorClass)}>
      {`${capitalizeFirst(resourceType)}s`}
    </span>
  );
};
